<template>
    <div>
        <div class="success">
            <img src="../../assets/owner/success@2x.png" alt="" srcset="">
        </div>
        <div>
            <p class="title">提交成功</p>
            <p class="suntitle">您可以在【台铃车主平台】公众号<br/> 车主中心查看个人车主码。</p>

            <div>
                <vue-qr :text="ownerCode" :size="180"></vue-qr>
            </div>
            <van-button type="primary" size="mini" class="btnInfo" @click="goInfo">
                信息维护
                <van-icon name="arrow" class="arrowicon" />
            </van-button>
        </div>
        <van-button class="btn" @click="goHome">车主码首页</van-button>
    </div>
</template>

<script>
import VueQr from 'vue-qr'
export default {
    components: { VueQr },
    data() {
        return {
            ownerCode: 'value'
        }
    },
    created () {
        let id = this.$store.state.ownerInfo.id;
        this.ownerCode = JSON.stringify({ownerCode:id})
    },
    methods: {
        goHome() {
            this.$router.push({
                path:'/ownercode'
            })
        },
        goInfo(){
            this.$router.push({
                path:'/ownerinfo'
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.arrowicon{
            vertical-align: middle;
        }
.success {
    text-align: center;
    margin-top: 20px;

    img {
        width: 104px;
        height: 116px;
    }
}

.title {
    font-size: 19px;
    font-weight: bold;
    color: #333333;
}

.suntitle {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
}

.btnInfo {
    background: #FFDCDE;
    border-radius: 13px;
    font-size: 14px;
    font-weight: 400;
    color: #FF232D;
    border: 0;
    padding: 6px 12px;
    margin-top: 10px;
}

.btn {
    background: #FF323A;
    box-shadow: 2px 3px 8px 1px rgba(255, 72, 72, 0.45);
    border-radius: 23px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    border: 0px;
    width: 80%;
    margin-top: 30px;
    margin-bottom: 40px;
}
</style>